import { atom } from "recoil";

export const mintStateAtom = atom({
  key: "mintState",
  default: "idle",
});
